import { Button, Popover } from "antd";
import ReactEmojiPicker from "emoji-picker-react";
import { StyledPopoverContent } from "./styles";
import { useCallback, useMemo, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";

const reactionsEmoji = ["👍", "❤️", "😂", "😮", "👀"];

const Reactions = ({ reactions, onClickReaction, loggedUser }) => {
  const [open, setOpen] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const selectedReaction = useMemo(() => {
    return reactions?.find(
      (e) => loggedUser?.user_id === (e?.sender_id || e?.user_id),
    );
  }, [reactions, loggedUser]);

  const onChangeReaction = useCallback(
    (emoji) => {
      setOpen(false);
      setShowEmojiPicker(false);
      onClickReaction(emoji);
    },
    [onClickReaction],
  );

  return (
    <div
      className={`message-reactions-div`}
      style={{ display: open ? "flex" : "none" }}
    >
      <Popover
        content={
          <StyledPopoverContent className="reaction-div">
            {showEmojiPicker ? (
              <div className="emoji-picker-container">
                <ReactEmojiPicker
                  onEmojiClick={(e) => {
                    onChangeReaction(e.emoji);
                  }}
                  height={350}
                  width={300}
                  previewConfig={{ showPreview: false }}
                  searchDisabled={window.innerWidth <= 768}
                  skinTonesDisabled={window.innerWidth <= 768}
                />
              </div>
            ) : (
              <>
                {[
                  ...reactionsEmoji,
                  ...(selectedReaction?.emoji &&
                  !reactionsEmoji.includes(selectedReaction?.emoji)
                    ? [selectedReaction?.emoji]
                    : []),
                ].map((e) => (
                  <span
                    key={e}
                    className={`reaction-span ${
                      selectedReaction?.emoji === e ? "selected" : ""
                    }`}
                    onClick={() => onChangeReaction(e)}
                  >
                    {e}
                  </span>
                ))}
                <span
                  className="reaction-span plus-emoji cursor-pointer"
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                  style={{ fontSize: "20px" }}
                >
                  <PlusOutlined />
                </span>
              </>
            )}
          </StyledPopoverContent>
        }
        trigger="click"
        rootClassName="reaction-popover"
        open={open}
        onOpenChange={setOpen}
      >
        <Button
          icon={<span>😊</span>}
          size="small"
          type="text"
          className="reaction-button"
        />
      </Popover>
    </div>
  );
};

export default Reactions;
